import { useStore } from '@assets/model/Store';
import { observer } from 'mobx-react';

import { useNavUtils } from '@assets/utils/NavUtils';
import { Flex } from '../UI/Flex/Flex';
import { DealDetailsHeader } from '../DealDetails/DealDetailsHeader/DealDetailsHeader';
import { PanelCompanyOverview } from '../Panel/PanelCompanyOverview/PanelCompanyOverview';
import { Split } from '../Split/Split';
import { Panel } from '../Panel/Panel';
import { ChartScoreBreakdown } from '../Charts/ChartScoreBreakdown';
import { ChartCompareCompanies } from '../Charts/ChartCompareCompanies';
import { CompanyCompareUtils } from '@assets/model/CompanyCompareUtils';

import * as style from './DealDashboard.module.less';
import { ChartCompanyRevenue } from '../Charts/ChartCompanyRevenue';
import { ScrollPanel } from '../Panel/ScrollPanel/ScrollPanel';
export const DealDashboard = observer(() => {
    const store = useStore();
    const navUtils = useNavUtils();
    const reportId = store.selectedReportId;
    const compareList = CompanyCompareUtils.findCompaniesToCompare(reportId, 4);

    return (
        <Flex direction="column" fillCell={true}>
            <DealDetailsHeader />
            <ScrollPanel>
                <Flex
                    direction="row"
                    style={{ width: '100%', minHeight: '450px' }}
                >
                    <Panel className={style.panelPaddingRight}>
                        <PanelCompanyOverview />
                    </Panel>
                    <Panel className={style.panelPaddingLeft}>
                        <ChartCompanyRevenue reportId={reportId} />
                    </Panel>
                </Flex>
                <Flex
                    direction="row"
                    style={{ width: '100%', minHeight: '450px' }}
                >
                    <Panel className={style.panelPaddingRight}>
                        <ChartScoreBreakdown reportId={reportId} />
                    </Panel>
                    <Panel className={style.panelPaddingLeft}>
                        <ChartCompareCompanies
                            reportId={reportId}
                            companies={compareList}
                        />
                    </Panel>
                </Flex>
            </ScrollPanel>
        </Flex>
    );
});
